import { useLocation } from 'react-router-dom';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Container } from '@mui/material';

function Summary() {
  const { state } = useLocation();
  const { allSessionData, course } = state || {};

  console.log('Summary received allSessionData:', allSessionData);

  if (!allSessionData || !allSessionData.length) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          No data available
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main', mb: 4, textAlign: 'center' }}>
        {course?.courseName || 'Yoga Course'} Report
      </Typography>
      <TableContainer component={Paper} sx={{ boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: 'primary.light' }}>
              <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }}>Pose Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }} align="right">
                Average Accuracy (%)
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }} align="right">
                Capture Duration (s)
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }} align="right">
                Frame Count
              </TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: 'text.primary' }} align="right">
                Good Posture Time (s)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allSessionData.map((data, index) => (
              <TableRow
                key={data.poseId}
                sx={{
                  '&:hover': {
                    backgroundColor: 'action.hover',
                    transition: 'background-color 0.2s'
                  },
                  backgroundColor: index % 2 === 0 ? 'background.paper' : 'grey.50'
                }}
              >
                <TableCell sx={{ color: 'text.primary' }}>{data.poseName}</TableCell>
                <TableCell align="right">{data.averageAccuracy.toFixed(1)}</TableCell>
                <TableCell align="right">{data.captureDuration.toFixed(1)}</TableCell>
                <TableCell align="right">{data.frameCount}</TableCell>
                <TableCell align="right">{data.goodPostureTime.toFixed(1)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
}

export default Summary;
